// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 2792 ? "BlogRelatedProducts" : chunkId) + ".js?id=" + {"2792":"e60926b8d00ea61c","4301":"90f225439bf3aa84","4945":"fb73b5ae5545883d","6152":"85064bf47cc5ddd5","6934":"4069b1b7b83433c2"}[chunkId] + "";
};